import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// reducers
import { GetLoggedUser as GetLoggedUserReducer } from '../../reducers/r_index';

//Components
import LoginMenuCmp from '../../components/shared/LoginMenuCmp';

// Material helpers
import { withStyles } from '@material-ui/core';

// Component styles
const styles = theme => ({
});

class LoginMenu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            redirect: false
        };

        this.tick = this.tick.bind(this);
    }

    tick() {
        this.props.getLoggedUser();
    }

    componentDidMount() {
        this.props.getLoggedUser();

        // Ogni 60 secondi controlla se l'utente è ancora loggato
        this.interval = setInterval(() => this.tick(), 60000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidUpdate(propsPrecedenti, statePrecedente) {

        // Se l'utente non è autenticato lo rimando alla home
        if (this.props.IsAuthenticated !== propsPrecedenti.IsAuthenticated) {
            if (!this.props.IsAuthenticated) {
                this.setState({ redirect: true });
            }
        }

        // una volta fatto il <Redirect> alla home, setto nuovamente redirect a false
        if (this.state.redirect !== statePrecedente.redirect) {
            if (this.state.redirect) {
                this.setState({ redirect: false });
            }
        }
    }

    render() {
        const { ...props } = this.props;

        if (this.state.redirect) {
            return <Redirect to='' />
        }
        else return <LoginMenuCmp {...props} />;

    }
}

LoginMenu.propTypes = {
    getLoggedUser: PropTypes.func.isRequired,
    getLoggedUserRequestStatus: PropTypes.string.isRequired,

    username: PropTypes.string.isRequired,
    codiceUtente: PropTypes.string.isRequired,
    IsAuthenticated: PropTypes.bool.isRequired,
};


const mapDispatchToProps = dispatch => ({
    getLoggedUser: () => { dispatch(GetLoggedUserReducer.creators.getLoggedUserRequest()) },
});

const mapStateToProps = state => ({
    getLoggedUserRequestStatus: state['logged-user'].status,

    username: state['logged-user'].username,
    codiceUtente: state['logged-user'].codiceUtente,
    IsAuthenticated: state['logged-user'].IsAuthenticated,
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(LoginMenu));